export type ReceiptEmailStatus = "not_sent" | "sending" | "accepted" | "failed" | "unknown";

export function receiptEmailMessage(status: ReceiptEmailStatus | undefined): string {
  switch (status) {
    case "accepted": return "Accepted by the email server. Inbox delivery is not confirmed.";
    case "failed": return "Not sent. You can safely try again.";
    case "sending": return "Sending now. Wait before trying again.";
    case "unknown": return "Handoff uncertain. Do not resend until someone checks delivery to avoid a duplicate.";
    default: return "No email attempt recorded.";
  }
}